import { InputHTMLAttributes, ReactNode } from 'react';
import * as S from './styled';

interface PropsInput extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  children?: ReactNode;
  width?: any;
}

export function Input({ children, label, width = 200, ...rest }: PropsInput) {
  return (
    <S.Container style={{ width: width }} >
      <S.Label>{label}</S.Label>
      <S.InputContainer>
        <S.Input {...rest} />
        {children}
      </S.InputContainer>
    </S.Container>
  );
}
